export default "__VITE_ASSET__f2a163c8__"